/* template */
<template><page><div :class='["rate-page"]'><base-container><div :class='["content"]'><div :class='["rate-wrapper"]'><cube-rate :value="value" mpxModelEvent="input" :disabled="(disabled)" :isCustomize="(customize)" :max="(currentMax)" :justify="(justify)" :allowHalf="(allowHalf)" @mpxModel='(e)=>__invoke(e, [["__model","value", "__mpx_event__", ["value"], undefined]])' @change='(e)=>__invoke(e, [["updateCurrentPoint"]])'><cube-rate-item v-for="(item, index) in (currentMaxArray)" :key="item.item" :index="(item)" :value="(value)"><div :class='["cube-rate-item-demo"]'></div></cube-rate-item></cube-rate></div><div :class='["options"]'><div :class='["title"]'>Options</div><div :class='["rate-option-list"]'><div :class='["group"]'><div :class='["group-item"]'><span :class='["item"]'>Disabled</span><mpx-switch :color="(switchColor)" :checked="(disabled)" @change='(e)=>__invoke(e, [["updateDisabled"]])'/></div><div :class='["group-item"]'><div :class='["item","sub"]'>Star Numbers</div><mpx-input type="number" :value="(max)" @input='(e)=>__invoke(e, [["updateMaxLength"]])' :class='["input-maxlength"]'/></div><div :class='["group-item"]'><div :class='["item","sub"]'>Input Point</div><mpx-input type="number" :value="(currentValue + '')" @input='(e)=>__invoke(e, [["updateValue"]])' :class='["input-maxlength"]'/></div><div :class='["group-item"]'><div :class='["item","sub"]'>Star Point</div><mpx-input type="number" :disabled="(true)" :value="(value + '')" :class='["input-maxlength"]'/></div><div :class='["group-item"]'><div :class='["item"]'>Justify</div><mpx-switch :color="(switchColor)" :checked="(justify)" @change='(e)=>__invoke(e, [["updateJustify"]])'/></div><div :class='["group-item"]'><div :class='["item"]'>CustomStar</div><mpx-switch :color="(switchColor)" :checked="(customize)" @change='(e)=>__invoke(e, [["updateCustomize"]])'/></div><div :class='["group-item"]'><div :class='["item"]'>AllowHalf</div><mpx-switch :color="(switchColor)" :checked="(allowHalf)" @change='(e)=>__invoke(e, [["updateAllowHalf"]])'/></div></div></div></div><cube-toast txt="为方便展示，示例中星星数最多为9～" ref="__mpx_ref_toast__"></cube-toast></div></base-container></div></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_72576386"}'>
.rate-page
  padding-top: 10px
  height 100%
  background-color rgba(239, 239, 244, .7)
  .cube-rate-item-demo
    width: 100%
    height: 100%
    background-size: 100%
    background-color: grey
  .options
    margin: 20px 0
    .rate-option-list
      .group
        border: 1px solid rgba(0, 0, 0, .1)
        border-radius: 5px
        .group-item
          display: flex
          align-items: center
          justify-content: space-between
          padding-right: 10px
          border-bottom: 1px solid rgba(0, 0, 0, .1)
          .item
            padding-left: 15px
            line-height: 52px
            height: 52px
            width: 120px
            text-align: left
          .sub
            font-size: 14px
            background-color: rgba(0, 0, 0, .04)
          .input-maxlength
          .input-width
            flex: 1
            margin-left: 15px
        .last
          border-bottom: none
.desc
  margin-top 15px

.cube-rate-item_active
  .cube-rate-item-demo
    background-color: orange
.cube-rate-item_half_active
  .cube-rate-item-demo
    background-color: blue
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_72576386"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_72576386"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_72576386"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-rate':getComponent(require("../../../packages/mpx-cube-ui/src/components/rate/index.mpx?isComponent&outputPath=components%2Findex1bb93227%2Findex")),'cube-rate-item':getComponent(require("../../../packages/mpx-cube-ui/src/components/rate/rate-item.mpx?isComponent&outputPath=components%2Frate-itemf29d1196%2Findex")),'cube-toast':getComponent(require("../../../packages/mpx-cube-ui/src/components/toast/index.mpx?isComponent&outputPath=components%2Findex7b472558%2Findex")),'mpx-switch':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-switch?isComponent"), {__mpxBuiltIn: true}),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>